// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"AZ-z","sponsoredTooltipWrapper":"BZ-z","sponsoredTooltip":"CZ-z","newCard":"DZ-z"};